export default {
  getLicense: (state) => state.license,
  getLicenseCopy: (state) => state.licenseCopy,
  getServiceFee: (state) => state.serviceFee,
  getVerificationLetter: (state) => state.verificationLetter,
  getButtons: (state) => state.buttons,
  getApplicationId: (state) => state.applicationId,
  getDocumentSpec: (state) => state.documentSpec,
  getDraft: (state) => state.draft,
  getRemark: (state) => state.remark,
  getDeclinedFields: (state) => state.declinedFields,
  getAcceptedFields: (state) => state.acceptedFields,
};
